import { OrderOperations } from "./OrderOperations"
import {
  OrderModificationAddresses,
  OrderModificationOrderLines,
  OrderModificationShippingFees,
  OrderModificationType
} from "lib/types/generated/graphql-types"
import { AddressType } from "lib/types/order"

export class ModificationAddresses extends OrderOperations {
  constructor(
    modification: (
      | OrderModificationShippingFees
      | OrderModificationAddresses
      | OrderModificationOrderLines
    )[]
  ) {
    super(modification?.filter((m) => m?.type === OrderModificationType.OrderAddresses))
  }

  public pendingModifications(): OrderModificationAddresses[] {
    return this.pendingList() as OrderModificationAddresses[]
  }

  public failedModifications(): OrderModificationAddresses[] {
    return this.failedList() as OrderModificationAddresses[]
  }

  public getPendingModification(): OrderModificationAddresses {
    const pendingList = this.pendingList() as OrderModificationAddresses[]
    return pendingList[0]
  }

  public getPendingModificationType(): AddressType | null {
    if (this.getPendingModification().addresses.data.billingAddress)
      return AddressType.BILLING_ADDRESS
    if (this.getPendingModification().addresses.data.shippingAddress)
      return AddressType.SHIPPING_ADDRESS
    return null
  }

  public getOngoingModification(): OrderModificationAddresses {
    const ongoingList = this.ongoingList() as OrderModificationAddresses[]
    return ongoingList[0]
  }
}
